import React, { useEffect } from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PlaceIcon from "@material-ui/icons/Place";
import SearchIcon from "@material-ui/icons/Search";
import TypeUtils from "../../../utils/TypeUtils";
import useTranslationJobs from "../useTranslationJobs";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import KeywordFilter from "./KeywordFilter";
import JobSort from "./JobSort";
import EmploymentTypeFilter from "./EmploymentTypeFilter";
import {useHistory, useLocation} from "react-router-dom";
import queryString from "query-string";
import FilterOption from "../../common/filters/FilterOption";
import StringUtils from "../../../utils/StringUtils";
import useMultiValueFilter from "../../common/filters/useMultiValueFilter";
import "./JobSearchPane.scss";
import WorkModeFilter from "./WorkModeFilter";

export default function JobSearchPane(props) {
  const {
    searchFilters,
    updateSearchFilters,
    sortValue,
    updateSortValue,
    pageSizeValue,
  } = props;

  const history = useHistory();
  const location = useLocation();

  const updateSearchFilterField = (field, values) => {
    if (values && values.length > 0) {
      updateSearchFilters(
        TypeUtils.shallowCopyObjectSetProp(searchFilters, field, values)
      );
    } else {
      const { [field]: deletedKey, ...filters } = searchFilters;
      updateSearchFilters(filters);
    }
  };

  // Add the parameters in the url when search keywords change
  useEffect(() => {

    history.push({
      pathname: location.pathname,
      search: queryString.stringify({
        companyname: searchFilters.companyName ? searchFilters.companyName : "",
        keyword: searchFilters.queryText ? searchFilters.queryText : "",
        location: searchFilters.location ? searchFilters.location : "",
        employmenttype: searchFilters.employmentType
          ? searchFilters.employmentType
          : "",
        sortby: sortValue,
        pagesize: pageSizeValue,
      }),
    });
  }, [searchFilters, sortValue, pageSizeValue, history, location.pathname]);

  const { t, loading: tLoading } = useTranslationJobs();
  useShowLoader(tLoading, "JobSearchPane");

  const placeIcon = <PlaceIcon />;
  const searchIcon = <SearchIcon />;

  const placePlaceholder = t("jobs:filter_job_location");
  const searchPlaceholder = t("jobs:filter_job_keyword");

  const onUncheckValue = (value) => {
    removeFilterValue(value);
  };

  const onUncheckPlaceValue = (value) => {
    removePlaceFilterValue(value);
  };

  // Normalize selected values to remove close duplicates with available values
  const normalizationFunction = StringUtils.normalizeString;

  const {
    filterValues,
    removeFilterValue,
    inputValue,
    setInputValue,
    addFilterValue,
  } = useMultiValueFilter(
    searchFilters.queryText,
    (value) => updateSearchFilterField("queryText", value),
    normalizationFunction
  );

  const {
    filterValues: placeFilterValues,
    removeFilterValue: removePlaceFilterValue,
    inputValue: placeInputValue,
    setInputValue: setPlaceInputValue,
    addFilterValue: addPlaceFilterValue,
  } = useMultiValueFilter(
    searchFilters.location,
    (value) => updateSearchFilterField("location", value),
    normalizationFunction
  );

  const lastPlaceIndexValue = placeFilterValues.length - 1;
  const lastKeywordIndexValue = filterValues.length - 1;

  // RENDER
  return (
    <Card className="JobSearchPane">
      <Card.Body className="job-search-pane-body">
        <Row className="searchContainer">
          <Col className="keyword-filter-col">
            <KeywordFilter
              icon={searchIcon}
              placeholder={searchPlaceholder}
              addFilterValue={addFilterValue}
              setInputValue={setInputValue}
              inputValue={inputValue}
            />
          </Col>
          <Col className="keyword-filter-col">
            <KeywordFilter
              icon={placeIcon}
              placeholder={placePlaceholder}
              addFilterValue={addPlaceFilterValue}
              setInputValue={setPlaceInputValue}
              inputValue={placeInputValue}
            />
          </Col>
        </Row>
        {(placeFilterValues.length > 0 || filterValues.length > 0) && (
          <>
            <Row>
              <Col className="job-filter">
                <EmploymentTypeFilter
                  selectedValue={searchFilters.employmentType}
                  updateSelectedValue={(value) =>
                    updateSearchFilterField("employmentType", value)
                  }
                />
              </Col>
              <Col className="job-filter">
                <WorkModeFilter
                  name={"workMode"}
                  selectedValue={searchFilters.workMode}
                  updateSelectedValue={(value) =>
                    updateSearchFilterField("workMode", value)
                  }
                />
              </Col>
              <Col className="job-filter">
                <JobSort
                  updateSelectedValue={(value) => updateSortValue(value)}
                  selectedValue={sortValue}
                />
              </Col>
            </Row>

            <Row>
              {filterValues.length > 0 && (
                <Col className="filter-option-col">
                  <Row className="filter-results-jobs-row">
                    <Col className="filter-results-jobs">
                      {t("jobs:filter_results_jobs")}
                    </Col>
                    <Col>
                      {filterValues.map((value, index) => (
                        <FilterOption
                          key={value}
                          index={index}
                          checked
                          onClick={() => onUncheckValue(value)}
                          indexValue={lastKeywordIndexValue}
                          value={value}
                        />
                      ))}
                    </Col>
                  </Row>
                </Col>
              )}
              {placeFilterValues.length > 0 && (
                <Col className="filter-option-col">
                  <Row className="filter-results-jobs-row">
                    {filterValues.length > 0 ? (
                      <Col className="filter-results-jobs">
                        {t("jobs:filter_in_for_location")}
                      </Col>
                    ) : (
                      <Col className="filter-results-jobs">
                        {t("jobs:filter_results_jobs")}
                      </Col>
                    )}
                    <Col>
                      {placeFilterValues.map((value, index) => (
                        <FilterOption
                          key={value}
                          index={index}
                          indexValue={lastPlaceIndexValue}
                          checked
                          onClick={() => onUncheckPlaceValue(value)}
                          value={value}
                        />
                      ))}
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          </>
        )}
      </Card.Body>
    </Card>
  );
}
